import React, { useCallback, useState } from 'react';
import { Input, Modal, Form } from 'antd';
import useProjectId from '@hooks/useProjectId';

const modalTitle = {
  add: 'Add Group',
  edit: 'Edit Group',
};

function useGroupNameModal(onOk, allGroupNames = []) {
  const [visible, setVisible] = useState(false);
  const [config, setConfig] = useState({
    mode: 'add',
    id: null,
    groupName: '',
  });
  const [form] = Form.useForm();
  const projectId = useProjectId();

  const open = (config = { mode: 'add' }) => {
    setConfig(config);
    setVisible(true);
    if (config?.groupName) {
      form.setFieldsValue({ groupName: config.groupName });
    }
  };
  const close = useCallback(() => {
    setVisible(false);
    form.resetFields();
  }, []);
  const modalOk = () => {
    form.validateFields().then(({ groupName }) => {
      onOk({
        groupName,
        type: 'Customize',
        id: config.id,
        projectId,
      });
      close();
    });
  };
  const modal = (
    <Modal
      visible={visible}
      onOk={modalOk}
      onCancel={close}
      className="group-edit-modal"
      cancelButtonProps={{ className: 'cancel-btn' }}
      maskClosable={false}
    >
      <h3 className="title">{modalTitle[config.mode]}</h3>
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="groupName"
          label="Group Name"
          colon={false}
          required={false}
          rules={[
            { required: true, message: 'Please enter group title' },
            {
              validator: (_, value) =>
                allGroupNames
                  .filter((i) => i.id !== config.id)
                  .find((i) => i.groupName === value?.trim?.())
                  ? Promise.reject(new Error('Group name already exists'))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input maxLength={20} autoComplete="off" />
        </Form.Item>
      </Form>
    </Modal>
  );
  return {
    modal,
    open,
    close,
  };
}

export default useGroupNameModal;
